import { useContextMotifDetails } from '../../contexts/motifDetailsContext'
import { Motif } from '../../types/motifs'
import MotifImageSection from './MotifImageSection'
import MotifInfoSection from './MotifInfoSection'
import MotifGallerySection from './MotifGallerySection'
import { isMobile, isTablet } from 'react-device-detect'
import { cn } from '../../utils/cn'

// smaller images on tablets
const imageSizeClassName = cn({
  '[--hd-gap:20px] [--hd-img-max:500px] [--hd-img:350px]': isTablet,
  '[--hd-gap:25px] [--hd-img-max:600px] [--hd-img:450px]': !isTablet,
})

interface Props {
  motif: Motif
}

const MotifDetailsItem = ({ motif }: Props) => {
  const { motifDetailsFadeOut } = useContextMotifDetails()

  if (isMobile && window.innerHeight < 600) {
    // Mobile-specific
    return (
      <div
        className={cn(
          imageSizeClassName,
          'flex min-h-[350px] items-center rounded-[24px] bg-white pb-[var(--hd-gap)] pl-[var(--hd-gap)] pr-[var(--hd-gap)] pt-[calc(var(--hd-gap)*2)] text-[12px] shadow-[0_2px_4px_0_rgba(0,0,0,0.2),0_4px_10px_0_rgba(0,0,0,0.2)] [--fk-gap:50px] [--fk-h1-size:46px] [--fk-h2-size:30px] [--fk-img-max:840px] [--fk-img:600px] [--fk-inventory-size:16px] [--fk-p-size:24px] [--fk-selector-size:22px] [--fk-settlement-size:21px] [--hd-h1-size:34px] [--hd-h2-size:22px] [--hd-inventory-size:12px] [--hd-p-size:18px] [--hd-selector-size:17px] [--hd-settlement-size:16px] max-sm:px-[24px] max-sm:pb-[24px] max-sm:pt-[60px] sm:text-[14px] xxl:pb-[var(--fk-gap)] xxl:pl-[var(--fk-gap)] xxl:pr-[var(--fk-gap)] xxl:pt-[calc(var(--fk-gap)*2)]',
        )}
      >
        <div
          className={cn(
            'mobile grid grid-cols-[200px_1fr] grid-rows-[200px] gap-[var(--hd-gap)] opacity-0 [transform:translateY(30px)] max-sm:w-full max-sm:grid-cols-[40%_60%] max-sm:grid-rows-[1fr] max-sm:gap-0 max-sm:[grid-row-gap:0px] sm:grid-cols-[var(--hd-img)_var(--hd-img)_auto] sm:grid-rows-[1fr] sm:[grid-row-gap:0px] xxl:min-h-[var(--fk-img)] xxl:grid-cols-[var(--fk-img)_var(--fk-img)_auto] xxl:[grid-column-gap:var(--fk-gap)] [&.fade-in]:animate-[fade-in-y30_0.3s_0.3s_ease_forwards] [&.fade-out]:animate-[fade-out-y30_0.3s_ease_forwards]',
            { 'fade-out': motifDetailsFadeOut, 'fade-in': !motifDetailsFadeOut },
          )}
        >
          <div className="mobile-image-wrapper">
            <MotifImageSection motif={motif} />
            <MotifGallerySection motif={motif} />
          </div>
          <MotifInfoSection motif={motif} />
        </div>
      </div>
    )
  }
  return (
    <div
      className={cn(
        imageSizeClassName,
        'flex min-h-[350px] items-center rounded-[24px] bg-white pb-[var(--hd-gap)] pl-[var(--hd-gap)] pr-[var(--hd-gap)] pt-[calc(var(--hd-gap)*2)] text-[12px] shadow-[0_2px_4px_0_rgba(0,0,0,0.2),0_4px_10px_0_rgba(0,0,0,0.2)] [--fk-gap:50px] [--fk-h1-size:46px] [--fk-h2-size:30px] [--fk-img-max:840px] [--fk-img:600px] [--fk-inventory-size:16px] [--fk-p-size:24px] [--fk-selector-size:22px] [--fk-settlement-size:21px] [--hd-h1-size:34px] [--hd-h2-size:22px] [--hd-inventory-size:12px] [--hd-p-size:18px] [--hd-selector-size:17px] [--hd-settlement-size:16px] max-sm:px-[24px] max-sm:pb-[24px] max-sm:pt-[60px] sm:text-[14px] xxl:pb-[var(--fk-gap)] xxl:pl-[var(--fk-gap)] xxl:pr-[var(--fk-gap)] xxl:pt-[calc(var(--fk-gap)*2)]',
      )}
    >
      <div
        className={cn(
          'grid grid-cols-[200px_1fr] grid-rows-[200px] gap-[var(--hd-gap)] opacity-0 [transform:translateY(30px)] max-sm:w-full max-sm:grid-cols-[40%_60%] max-sm:grid-rows-[1fr] max-sm:gap-0 max-sm:[grid-row-gap:0px] sm:grid-cols-[var(--hd-img)_var(--hd-img)_auto] sm:grid-rows-[1fr] sm:[grid-row-gap:0px] xxl:min-h-[var(--fk-img)] xxl:grid-cols-[var(--fk-img)_var(--fk-img)_auto] xxl:[grid-column-gap:var(--fk-gap)] [&.fade-in]:animate-[fade-in-y30_0.3s_0.3s_ease_forwards] [&.fade-out]:animate-[fade-out-y30_0.3s_ease_forwards]',
          { 'fade-out': motifDetailsFadeOut, 'fade-in': !motifDetailsFadeOut },
        )}
      >
        <MotifImageSection motif={motif} />
        <MotifInfoSection motif={motif} />
        <MotifGallerySection motif={motif} />
      </div>
    </div>
  )
}

export default MotifDetailsItem
